import React from 'react'
import { connect } from 'react-redux'
import Share from 'components/share'
import MetaTags from 'components/metatags/metatags'
import { imagePath } from 'utils/image'
import { mapLanguageToComponentProps } from 'i18n'
import { formatDateTimeTimezone } from 'utils/date'
import { PageHeader } from 'components/page-header'
import { MediumHeaderContent } from 'components/page-header/medium-header-content'
import { I18nComponentType } from 'i18n/i18n-types'
import { CompanyType, PositionType } from 'types'

interface JobAdContainerProps {
  i18n: I18nComponentType
  jobAd: PositionType & { hideShare: boolean }
  company: CompanyType
  children?: React.ReactNode | React.ReactNode[]
  locationId?: string
}

export const JobAdContainer = ({
  jobAd,
  company,
  children,
  i18n,
  locationId,
}: JobAdContainerProps) => {
  const endTime = jobAd.endTime
    ? i18n.jobAdContainer.endTime(formatDateTimeTimezone(jobAd.endTime))
    : ''

  const MetaTagsProps: { title?: string, description?: string, jobUrlSlug?: string, photo?: string } = {
    title:  `${company.name}: ${jobAd.title}` ,
    description: jobAd.description,
    jobUrlSlug: `careers/${jobAd.language}/${company.slug}/${jobAd.slug}`,
    photo: jobAd.logo ? imagePath(jobAd.logo) : ''
  }

  const share = jobAd.hideShare ? null : (
    <Share
      key="share"
      services={['linkedin', 'facebook', 'x-twitter', 'google']}
      url={`/careers/${jobAd.language}/${company.slug}/${jobAd.slug}`}
      title={jobAd.title}
      summary={jobAd.description}
      locationId={locationId}
    />
  )

  return (
    <div className="job-ad-container">
      {jobAd.slug ? (
        <div>
          <MetaTags {...MetaTagsProps} />
          <PageHeader photo={imagePath(jobAd.photo)} actionsRight={[share]}>
            <MediumHeaderContent
              title={jobAd.title}
              description={jobAd.location}
              status={endTime}
            />
          </PageHeader>
          {children}
        </div>
      ) : null}
    </div>
  )
}

export default connect(mapLanguageToComponentProps())(JobAdContainer)
